import Vue from '@/index.js'

import page from '@/mixins/page'
export default new Vue({
  el: '#app',
  mixins: [page],
  components: {
    'layout-category-header': () => import('@/components/layout/category/layout-category-header.vue'),
    'layout-catalog-category-card': () => import('@/components/layout/catalog/layout-catalog-category-card.vue'),
    'layout-category-products': () => import('@/components/layout/category/layout-category-products.vue'),
    'layout-product-card': () => import('@/components/layout/product/layout-product-card.vue'),
    'layout-blackfriday-page': () => import('@/components/layout/blackfriday/layout-blackfriday-page.vue')
  }
})
